<template>
  <nav>
    <ul class="flex flex-col mb-12">
      <VNavLink v-for="(link, index) in links" :key="`navlink-${index}`" :linkProps="link">
        <VSvgIcon :name="link.icon" class="w-6 h-6" />
      </VNavLink>
    </ul>

    <div class="text-center">
      <!-- customer tech support -->
      <div class="md:hidden block py-2 text-ricoma-gray-500 font-semibold">
        <a href="https://support.ricoma.com/hc/en-us" target="_blank">{{ $t('header.support') }}</a>
      </div>

      <!-- contact us -->
      <div class="md:hidden block py-2 pb-10 text-ricoma-gray-500 font-semibold">
        <a href="https://ricoma.com/pages/contact-us" target="_blank">{{ $t('header.contact') }}</a>
      </div>
    </div>
  </nav>
</template>

<script>
import VNavLink from '@/components/base/VNavLink';
import VSvgIcon from '@/components/base/VSvgIcon';

const LINKS = [
  { to: '/', exact: true, name: 'dashboard', icon: 'dashboard' },
  { to: '/products', name: 'products', icon: 'products' },
  { to: '/training', name: 'preTraining', icon: 'pretraining' },
  { to: '/post-training', name: 'postTraining', icon: 'pretraining' },
  { to: '/schedules', name: 'schedule', icon: 'calendar' },
  { to: '/orders', name: 'orders', icon: 'orders' },
  { to: '/transactions', name: 'transactions', icon: 'cash-usd' },
  { to: '/referrals', name: 'referrals', icon: 'rewards' },
];

export default {
  name: 'NavLinks',
  components: { VNavLink, VSvgIcon },
  computed: {
    links() {
      return LINKS.filter(item => {
        if (
          (item.name === 'preTraining' || item.name === 'referrals') &&
          this.$user.subsidiary_id === '3'
        ) {
          return false;
        }
        return true;
      }).map(l => ({
        ...l,
        name: this.$t(`nav.${l.name}`),
      }));
    },
  },
};
</script>
